class SocialReports extends HTMLElement {
    constructor() {
        super();
        this.swiperContainer = this.querySelector('.swiper');
        this.swiper = null;
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer && !this.swiper) {
            const prevButton = this.querySelector('.swiper-button-prev');
            const nextButton = this.querySelector('.swiper-button-next');
            const paginationEl = this.querySelector('.swiper-pagination');
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 3,
                spaceBetween: 48,
                autoHeight: true,
                navigation: {
                    nextEl: nextButton || null,
                    prevEl: prevButton || null,
                },
                pagination: {
                    el: paginationEl || null,
                    clickable: true,
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 24
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 28
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 18
                    },
                    1100: {
                        slidesPerView: 3,
                        spaceBetween: 48
                    }
                }
            })
        }
    }
}
customElements.define('social-reports', SocialReports);